import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GlobalService } from '../../../service/global.service';

@Component({
  selector: 'app-view-product-form-details',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './view-product-form-details.component.html',
  styleUrl: './view-product-form-details.component.scss'
})
export class ViewProductFormDetailsComponent {

  @Input() orderData: any = null;
  @Output() close = new EventEmitter<boolean>();

  constructor(public gS:GlobalService){
    
  }
  ngOnInit() {
    console.log(this.orderData, 'orderData');

  }

  handleOffcanvasClose() {
    this.orderData = null;
    this.close.emit(true);
  }
}
